let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c0Efy")).then(() => parcelRequire('lC9hp'));